<template>
  <div>
    <!-- {{user}} -->
    <!-- <h2>{{ user.selector1 }}</h2> -->
    <!-- <hr> -->
    <div class="">
      <!-- <p>Family Name: {{ user.employer_name }}</p> -->
      <div class="row">
        <div class="col-lg-5 mt-3">
          <h4>Contact Information</h4>
          <p>{{ user.first_name }} {{ user.last_name }}</p>
          <p v-if="user.features[0]">Spouse/Partner: {{ user.features[0] }} {{ user.features[1] }}</p>
          <p>{{ user.email }}</p>
          <p>{{ user.phone }}</p>

          <h4 class="mt-4">Address</h4>
          <p>{{ user.city }}</p>
          <p>{{ user.provincestate }}</p>
          <p>{{ user.postal_code }}</p>

          <h4 class="mt-4">Notes</h4>
          <label>Start Date: {{ new Date(user.available_date).toDateString() }}</label>
          <p v-if="user.marketing_source">How did you hear about us: {{ user.marketing_source }}</p>
        </div>
        <div class="col-lg-7 mt-3 field-of-fields">
          <h4>Service Information</h4>
          <p>Number of Children: {{ user.text1 }}</p>
          <p>Age of Children: {{ user.text2 }}</p>
          <p>Do children have any special needs or medical conditions: {{ user.selector1 }}</p>
          <pre>{{ user.text3 }}</pre>
          <label>Pay Rate</label>
          <pre>{{ user.text4 }}</pre>
          <label>Family Schedule</label>
          <pre>{{ user.text5 }}</pre>
          <label>Household tasks nanny will be expected to perform</label>
          <pre>{{ user.text6 }}</pre>
          <label>Family philosophies regarding childcare, discipline, etc.</label>
          <pre>{{ user.text7 }}</pre>
          <label>Does your child need to be taken to after school activity? </label>
          <p>{{ user.selector2 }}</p>
          <pre>{{ user.text8 }}</pre>
          <label>Do you encourage play dates? If so, in your home or away?</label>
          <pre>{{ user.text9 }}</pre>
          <label>Will you provide paid vacation or holidays for your nanny?</label>
          <p>{{ user.selector3 }}</p>
          <label>Any special privileges given to the nanny</label>
          <pre>{{ user.text11 }}</pre>
          <label>Home description</label>
          <pre>{{ user.text12 }}</pre>
          <label>Neighborhood description</label>
          <pre>{{ user.text13 }}</pre>
          <label>Overall experience with nannies</label>
          <pre>{{ user.text14 }}</pre>
          <label>Previous nannies</label>
          <pre>{{ user.text15 }}</pre>
          <label>Pets</label>
          <pre>{{ user.text20 }}</pre>
          <label>Housekeeper?</label>
          <p>{{ user.selector4 }}</p>
          <label>Nanny expected to prepare meals?</label>
          <p>{{ user.selector5 }}</p>
          <label>Nanny required to travel with the family?</label>
          <p>{{ user.selector6 }}</p>
          <pre>{{ user.text16 }}</pre>
          <label>Work from home?</label>
          <p>{{ user.selector7 }}</p>
          <label>Nanny required to have their own car?</label>
          <p>{{ user.selector8 }}</p>
          <pre>{{ user.text17 }}</pre>
          <label>Total hours expected to work each week</label>
          <pre>{{ user.text18 }}</pre>
          <label>Days/Hours</label>
          <pre>{{ user.text19 }}</pre>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['user'],
}
</script>



// WEBPACK FOOTER //
// src/components/employers/applications/ApplicationView.vue